import type { LucideIcon } from 'lucide-react';

export function IconBox({ icon: Icon, tone = 'green' }: { icon: LucideIcon; tone?: 'green' | 'gold' | 'blue' | 'red' }) {
  return <span className={`icon-box icon-${tone}`}><Icon size={18} strokeWidth={1.9} /></span>;
}

export function StatusDot({ status }: { status: string }) {
  const tone = status === 'FRESH' || status === 'MANUAL' || status === 'CONFIRMED'
    ? 'good' : status === 'FAILED' || status === 'MISSING' ? 'bad' : 'warn';
  return <span className={`status-dot status-${tone}`} aria-label={status} />;
}
